<script>
export default {
  name: 'NavigateBar',
  props: {
    rightOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleLeftClick(e) {
      this.$emit('leftClick', e)
    },
    handleRightClick(e) {
      this.$emit('rightClick', e)
    },
    navDependOnBrowsers() {
      if (navigator.userAgent.match(/chrome|chromium|crios/i)) {
        return "chrome";
      } else if(navigator.userAgent.match(/firefox|fxios/i)) {
        return "firefox";
      } else if(navigator.userAgent.match(/safari/i)) {
        return "safari";
      } else if(navigator.userAgent.match(/opr\//i)) {
        return "opera";
      } else if(navigator.userAgent.match(/edg/i)) {
        return "edge";
      } else{
        return "undefined";
      }
    },
    navDependOnDevices() {
      if (navigator.userAgent.match(/Android/i)) {
        if(navigator.userAgent.match(/Nexus/i)) {
          return "android_nexus";
        }
        else {
          return "android";
        }
      } else if(navigator.userAgent.match(/BlackBerry/i)) {
        return "blackberry";
      } else if(navigator.userAgent.match(/iPhone|iPod|iPad/i)) {
          if(navigator.userAgent.match(/iPad/i)) {
            return "ios_ipad";
          }
          else {
            return "ios";
          }
      } else if(navigator.userAgent.match(/Opera Mini/i)) {
        return "operamini";
      } else if(navigator.userAgent.match(/IEMobile/i)) {
        return "windows";
      } else{
        return "undefined";
      }
    }
  },
}
</script>

<template>
  <div :class="['navigate-bar', this.navDependOnDevices(), this.navDependOnBrowsers(), { center: rightOnly }]">
    <button
      class="s-button grey-light-btn left-btn"
      v-if="!rightOnly"
      @click="handleLeftClick"
    >
      <x-icon-back />
    </button>
    <button
      class="s-button yellow-btn right-btn"
      :class="{ half: rightOnly }"
      @click="handleRightClick"
    >
      <slot></slot>
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import 'navigate.scss';
</style>
